module.exports = __webpack_public_path__ + "img/list17.269fa7ee.jpeg";